"use client";

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export function FloatingPaths({ position = 1 }: { position?: number }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const paths = Array.from({ length: 12 }, (_, i) => ({
    id: i,
    d: `M-${280 - i * 16 * position} -${140 + i * 12}C-${220 - i * 16 * position} ${120 - i * 12} ${180 - i * 16 * position} ${220 - i * 12} ${580 - i * 16 * position} ${320 - i * 12}C${880 - i * 16 * position} ${420 - i * 12} ${1080 - i * 16 * position} ${780 - i * 12} ${1180 - i * 16 * position} ${880 - i * 12}`,
    width: 0.7 + i * 0.06,
    duration: 26 + (i % 4) * 6,
  }));

  if (!mounted) {
    return null;
  }

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
      <svg
        className="w-full h-full text-[#FFB51D]/25 dark:text-[#FFB51D]/20"
        viewBox="0 0 1200 800"
        preserveAspectRatio="none"
        fill="none"
      >
        <title>Background Paths</title>
        {paths.map((path) => (
          <motion.path
            key={path.id}
            d={path.d}
            stroke="currentColor"
            strokeWidth={path.width}
            strokeOpacity={0.14 + path.id * 0.015}
            initial={{ pathLength: 0.5, pathOffset: 0 }}
            animate={{
              pathOffset: [0, 1],
            }}
            transition={{
              duration: path.duration,
              repeat: Infinity,
              ease: "linear",
            }}
          />
        ))}
      </svg>
    </div>
  );
}
